export const TYPES = {
  CollaborateService: Symbol('CollaborateService'),
};

export enum InvitationStatus {
  SENT = 1,
  ACCEPTED = 2,
  REMOVED = 3,
  EXPIRED = 4,
}

export type Permission = {
  id: number;
  type: 'shared' | 'owner';
  user: number;
  user_id: string;
};

type UserDetail = {
  content: string;
  type: string;
};

type User = {
  id: number;
  uuid?: string;
  nickname: string;
  profilePicture?: string;
  details: UserDetail[];
};

export type UserInfo = {
  id: number;
  user: User;
  details: UserDetail[];
  invitation?: {
    membershipId: number;
    isPending: boolean;
    isExpired: boolean;
    invitedAt: string;
  };
};

export type Collaborator = {
  id: string | number;
  permissionUserId?: number;
  name: UserInfo['user']['nickname'];
  email: UserInfo['user']['details'][0]['content'];
  sourceUrl?: UserInfo['user']['profilePicture'];
  invitation?: {
    isPending: boolean;
    isExpired: boolean;
    membershipId: number;
    invitedAt: string;
  };
  permissionId?: Permission['id'];
  permissionType?: Permission['type'];
};

export type Project = {
  projectId: number;
  encodedId: string;
};

/**
 * Registered user has a unique identifier
 * While the user is not registered, the identifier is an email
 */
export type UserId = number | string;
